/**
 * Custom Guten Group Functionality
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <john@chatmandesign.com>
 * @link      http://chatmandesign.com
 */
(function($) {
    
    /**
     * Sets background color based on specified class
     */
    function groupBackgroundColorInit() {
        let backgroundRegex = /background-[0-9a-zA-Z]+/;
        $('.wp-block-group[class*="background-"]').each(function() {
            let groupClasses = $(this).attr('class');
            let backgroundColor = backgroundRegex.exec(groupClasses);
            let color = backgroundColor !== null ? backgroundColor[0].replace('background-', '') : '';
            if( color.length ) {
                // Check whether RGB or color keyword
                // Color keywords need to be lowercase
                let colorRegex = /[a-z]+/;
                if( color.match(colorRegex) !== null ) {
                    $(this).css('background-color', color); 
                } else {
                    $(this).css('background-color', '#' + color); 
                }
            }
        });
    }

    //! – DOM READY
    $(function() {
        groupBackgroundColorInit();

    }); // jQuery document ready 

})(jQuery);